import React from 'react'
import EventTicker from '../EventTicker/EventTicker'

export default function Nav({ left, center, right }) {
  return (
    <>
      <EventTicker isVisible={false} />
      <div className='max-w-screen-xl mx-auto px-4'>
        <nav className='flex items-center justify-between py-2'>
          <div>{left}</div>
          <div>{center}</div>
          <div>{right}</div>
        </nav>
      </div>
    </>
  )
}
